export default __webpack_public_path__ + "static/media/Talons of Necrotic Dread.bed34aa0.jpg";